import { useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Button, Divider, Typography } from '@material-ui/core';

import { AdminEndpointsByEndpoint, AdminEndpointsByRole } from 'components';
import { useAllRoles } from 'hooks/roles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      marginTop: theme.spacing(4),
    },
    divider: {
      margin: theme.spacing(1.5, 0),
    },
    root: {
      margin: theme.spacing(5, 'auto'),
      maxWidth: theme.breakpoints.values.md,
    },
    title: {
      fontWeight: 700,
    },
    tabButton: {
      ...theme.typography.body1,
      borderRadius: 0,
    },
    tabButtonActive: {
      boxShadow: `0 3px 0 0 ${theme.palette.primary.main}`,
      fontWeight: 700,
    },
    tabLabel: {
      marginRight: theme.spacing(1),
    },
    tabs: {
      alignItems: 'center',
      borderBottom: `1px solid ${theme.palette.divider}`,
      display: 'flex',
      marginBottom: theme.spacing(2),
      paddingBottom: 1,
    },
  }),
);

const AdminEndpointsPanel = () => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState<'endpoints' | 'roles'>('endpoints');

  const { data: allRoles = [] } = useAllRoles(true);

  return (
    <div className={classes.root}>
      <Typography className={classes.title} variant="h4">
        Endpoints
      </Typography>
      <div className={classes.content}>
        <div className={classes.tabs}>
          <Typography className={classes.tabLabel}>View by:</Typography>
          <Button
            className={`${classes.tabButton} ${
              selectedTab === 'endpoints' ? classes.tabButtonActive : ''
            }`}
            onClick={() => setSelectedTab('endpoints')}
          >
            Endpoint
          </Button>
          <Button
            className={`${classes.tabButton} ${
              selectedTab === 'roles' ? classes.tabButtonActive : ''
            }`}
            onClick={() => setSelectedTab('roles')}
          >
            Organization
          </Button>
        </div>

        {selectedTab === 'endpoints' && (
          <AdminEndpointsByEndpoint
            roles={allRoles}
            dividerEl={<Divider className={classes.divider} />}
          />
        )}

        {selectedTab === 'roles' && (
          <AdminEndpointsByRole
            roles={allRoles}
            dividerEl={<Divider className={classes.divider} />}
          />
        )}
      </div>
    </div>
  );
};

export default AdminEndpointsPanel;
